module.exports = __webpack_public_path__ + "static/media/vaccum.c4824bfd.png";